const HeadlineScrollerSelectors = {
  headlines: "[data-headline-scroller]"
}

const HeadlineScrollerOptions = {
  speed: .75,
  acceleration: .25,
}

class HeadlineScroller {
  constructor() {
    this._process();
    this._lazyload();
  };

  _process() {
    this.headlines = document.querySelectorAll(HeadlineScrollerSelectors.headlines);
    this._wrap();
  };

  _wrap() {
    this.headlines.forEach((headline) => {
      if (headline.querySelector("span.original")) {
        return;
      }

      headline.intersectionObserver = this._createIntersectionObserver(headline);

      headline.wrapper = document.createElement("div");
      headline.originalText = headline.innerHTML;
      
      headline.originalSpan = document.createElement("span");
      headline.originalSpan.innerHTML = headline.originalText;
      headline.originalSpan.classList.add("original");
      headline.wrapper.append(headline.originalSpan);
      headline.innerHTML = "";
      headline.append(headline.wrapper);
      
      headline.cloneSpan = document.createElement("span");
      headline.cloneSpan.innerHTML = headline.originalText;
      headline.cloneSpan.classList.add("clone");

      headline.multiplyFactor = this._multiplyFactor(headline);
      
      for (let index = 0; index < headline.multiplyFactor; index++) {
        this._addCopy(headline, true);
      }
    })
  };

  _createIntersectionObserver(headline) {
    return new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio < 0.55) {
          this._addCopy(headline);
        }
      });
    }, {
      threshold: .5
    });
  };

  _multiplyFactor(headline) {
    return (
      (
        Math.abs(
          Math.floor(
            (window.innerWidth - headline.originalSpan.offsetWidth) / headline.originalSpan.offsetWidth / 2
          )
        ) + 1
      ) * 2
    );
  };

  _addCopy(headline, setup=false) {
    if (headline.cloneIndex == undefined) {
      headline.cloneIndex = 1;
    }

    let cssClass = (headline.cloneIndex++ % 2) ? "odd" : "even";

    let spanA = headline.cloneSpan.cloneNode(true);
    spanA.classList.add(cssClass);
    headline.wrapper.prepend(spanA);
    
    let spanB = headline.cloneSpan.cloneNode(true);
    spanB.classList.add(cssClass);
    headline.wrapper.append(spanB);
    headline.intersectionObserver.observe(spanB);
  }

  _move(headline) {
    let offsetScrollPositionY = window.scrollY - headline.offsetTop;

    if (headline.movedLeft == undefined) {
      headline.movedLeft = 0;
    }
    if (headline.scrollPosition == undefined) {
      headline.scrollPosition = offsetScrollPositionY;
    }

    headline.acceleration = (headline.scrollPosition - offsetScrollPositionY) * HeadlineScrollerOptions.acceleration;
    headline.movedLeft = (headline.movedLeft - HeadlineScrollerOptions.speed) + headline.acceleration;
    headline.style.setProperty("--headline-scroll-amount", (headline.movedLeft + "px"));
    headline.scrollPosition = offsetScrollPositionY;

    headline.moveAnimation = requestAnimationFrame((timestamp) => {
      this._move(headline)
    })
  };

  start(headline) {
    headline.moveAnimation = requestAnimationFrame((timestamp) => {
      this._move(headline);
    })
  };

  stop(headline) {
    cancelAnimationFrame(headline.moveAnimation);
  }

  _lazyload() {
    this.ll = new LazyLoad({
      callback_enter: (element) => { this._onEnter(element) },
      callback_exit: (element) => { this._onExit(element) },
      threshold: 0,
    }, this.headlines);
  };

  _onEnter(headline) {
    headline.classList.remove("disappear");
    headline.classList.add("appear");
    this.start(headline);
  };

  _onExit(headline) {
    this.stop(headline);
  };

  update() {
    this._process();
    this.ll.update(this.headlines);
  };
}

document.addEventListener("DOMContentLoaded", () => {
  window.HeadlineScroller = new HeadlineScroller();
})
